/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function RecycledWoolModel(props) {
	const { nodes, materials } = useGLTF("models/recycledWool.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube020.geometry}
				material={materials["recycle.001"]}
				position={[-0.029, 0.363, -0.023]}
				scale={[1.106, 0.411, 1.106]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube018.geometry}
				material={materials["Plain Brown Texture.001"]}
				position={[0.258, 0.037, 0.457]}
				rotation={[0, 1.38, 0.347]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube017.geometry}
				material={materials["Plain Black Texture.001"]}
				position={[0.123, 0.154, 0.578]}
				rotation={[0, 1.15, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube016.geometry}
				material={materials["Plain Blue Texture.001"]}
				position={[-0.167, 0.141, 0.578]}
				rotation={[0, 0.824, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube015.geometry}
				material={materials["Stripe Green Dimout.001"]}
				position={[-0.462, 0.124, 0.578]}
				rotation={[0, 0.529, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube014.geometry}
				material={materials["Stripe Blue Dimout.001"]}
				position={[-0.733, 0.114, 0.578]}
				rotation={[0, 0.263, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube013.geometry}
				material={materials["Plain Green Texture.001"]}
				position={[-1.049, 0.094, 0.578]}
				rotation={[0, 0, 0.307]}
				scale={[1.44, 1.44, 0.199]}
			/>
		</group>
	);
}

useGLTF.preload("models/recycledWool.glb");
